<template>
  <div>
    <Header />
    <main>
      <NuxtPage />

      <ClientOnly>
        <Transition
          appear
          enter-active-class="transition-all duration-500 ease-[cubic-bezier(0.25,1,0.5,1)]"
          enter-from-class="-translate-x-[120%] opacity-0"
          enter-to-class="translate-x-0 opacity-100"
          leave-active-class="transition-all duration-300 ease-in"
          leave-from-class="translate-x-0 opacity-100"
          leave-to-class="-translate-x-[120%] opacity-0"
        >
          <PopUp
            v-if="isPopupVisible"
            :title="homepageNotice.title"
            :content="homepageNotice.content"
            @close="handleClose"
          />
        </Transition>
      </ClientOnly>
    </main>
    <Footer />
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from 'vue'

const i18nHead = useLocaleHead()

const { data } = await usePersistedFetch('HomepageNotice')
const homepageNotice = computed(() => data.value?.homepageNotice)

const isPopupVisible = ref(false)
const STORAGE_KEY = 'popup_closed_date'

const getTodayString = () => new Date().toISOString().split('T')[0]

const handleClose = () => {
  isPopupVisible.value = false
  if (import.meta.client) {
    localStorage.setItem(STORAGE_KEY, getTodayString())
  }
}

onMounted(() => {
  if (!homepageNotice.value) return

  const closedDate = localStorage.getItem(STORAGE_KEY)
  const today = getTodayString()

  if (closedDate !== today) {
    isPopupVisible.value = true
  }
})

useHead(() => ({
  htmlAttrs: {
    lang: i18nHead.value.htmlAttrs?.lang,
  },
  link: i18nHead.value.link || [],
}))

useDynamicSeo({
  data: [],
})
</script>

<style>
.page-enter-active,
.page-leave-active {
  transition: opacity 0.3s ease;
}
.page-enter-from,
.page-leave-to {
  opacity: 0;
}
</style>
